import { CLEAR_PAGE } from '../base/types';
import { DELETE_FEEDBACK, FETCH_FEEDBACKS, UPDATE_FEEDBACK } from './types';

const INIT_STATE = {
  isLoading: false,
  isLoaded: false,
  data: []
};

const feedbacksReducer = (state = INIT_STATE, { type, payload }) => {
  switch (type) {
    case `${FETCH_FEEDBACKS}_PENDING`:
      return {
        ...state,
        isLoading: true,
      };
    case `${FETCH_FEEDBACKS}_FULFILLED`:
      console.log('payload', payload);
      return {
        ...state,
        data: payload,
        isLoaded: true,
        isLoading: false,
      };
    case `${FETCH_FEEDBACKS}_REJECTED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
      };

    case `${UPDATE_FEEDBACK}_FULFILLED`:
      return {
        ...state,
        data: state.data.map((i) => {
          if (Number(i.id) === Number(payload.id)) {
            return payload;
          }
          return i;
        }),
      };

    case `${DELETE_FEEDBACK}_FULFILLED`:
      return {
        ...state,
        data: state.data.filter((i) => Number(i.id) !== Number(payload?.id)),
      };

    case CLEAR_PAGE:
      return payload === 'feedbacks' ? INIT_STATE : state;

    default:
      return state;
  }
};

export default feedbacksReducer;
